module.exports = __webpack_public_path__ + "static/img/rank_112.9008746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_112.png
// module id = pbJl
// module chunks = 1